import { baseApi } from "./baseApi";
import { toast } from "react-toastify";

export interface Gallery {
  _id: string;
  title: string;
  creator: string;
  description: string;
  dateAdded: string;
  dateMade?: string;
  imageFilename?: string;
}

export const galleryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGallery: builder.query<Gallery[], void>({
      query: () => "/gallery",
      providesTags: ["Gallery"],
    }),
    addGallery: builder.mutation<Gallery, FormData>({
      query: (formData) => ({
        url: "/gallery/upload",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Gallery"],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
          toast.success("Art added successfully", {
            position: "bottom-right",
          });
        } catch {
          // error handled by caller
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetGalleryQuery, useAddGalleryMutation } = galleryApi;
